<template>
  <div class="vi-date-picker">
    <datepicker
      :value="value"
      :disabled-dates="disabledDates"
      :placeholder="placeholder"
      @input="onInput"
    />
    <div class="calendar-icon">
      <fa-icon icon="calendar-alt"/>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import ViInput from "./ViInput";
  export default {
    name: 'ViDatePicker',
    components: {ViInput, Datepicker},

    props: {
      value: {
        type: Date
      },
      disabledDates: {
        type: Object
      },
      placeholder: {
        type: String
      }
    },

    methods: {
      onInput(val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/vars";
.vi-date-picker {
  position: relative;
  color: #000000;
  .calendar-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
    pointer-events: none;
  }
  input {
    min-width: 180px;
    border-radius: 10px;
    border: none;
    padding: 6px 10px;
    /*text-align: center;*/
    font-size: 16px;
    outline: none;

    &:focus {
      box-shadow: 0 0 1px 2px #08A5B4;
    }
  }

  .vdp-datepicker__calendar {
    border-radius: 10px;
    border: 3px solid #05a5b4;
    overflow: hidden;

    .cell.selected {
      background: $clBrand;
      color: #ffffff;
    }

    .cell.selected:hover {
      background: lighten($clBrand, 10);
    }

    .cell:not(.blank):not(.disabled).day:hover, .cell:not(.blank):not(.disabled).month:hover, .cell:not(.blank):not(.disabled).year:hover {
      border: 1px solid $clBrand;
    }
  }



}
</style>
